// extracted by mini-css-extract-plugin
module.exports = {"gigantic":"text_gigantic__3fg_l","large":"text_large__13Yts","small":"text_small__eW9En","center":"text_center__3Rl4s"};